export function getError(response: any) {
    let errors: any[] = [];
    return response && response.data && response.data.errors && Object.keys(response.data.errors).forEach((k) => {
        const temp: any = [...response.data.errors[k]];
        errors = errors.concat(temp);
    });
}